import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TabBar } from 'antd-mobile'
import {
  AppOutline,
  BillOutline,
  UserOutline,
  ScanningOutline,
} from 'antd-mobile-icons'
import { isWxOrAli } from "../../utils/env";

import "./style.less"

const BottomNav = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location

  const setRouteActive = (value) => {
    navigate(value)
  }

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();

  const tabs = [
    {
      key: '/home',
      title: '首页',
      icon: <AppOutline />,
    },
    // {
    //   key: '/scan',
    //   title: '充电',
    //   icon: <ScanningOutline />,
    // },
    {
      key: '/order',
      title: '订单',
      icon: <BillOutline />,
    },
    {
      key: '/user',
      title: '我的',
      icon: <UserOutline />,
    },
  ]

  return (
    <div className={aliOrWx === 'wechat' ? 'bottom' : 'bottom-alipay'}>
      <TabBar activeKey={pathname} onChange={value => setRouteActive(value)}>
        {tabs.map(item => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
        ))}
      </TabBar>
    </div>
  )
}

export default BottomNav;